module.exports = __webpack_public_path__ + "media/message-124468.03acd22c.mp3";